<template>
  <SuccessModal :showSuccessModal="state.showSuccessModal" :closeModal="handleSuccessModal" :data="successModalData" />
  <section class="subscription-modal-form">
    <div
        class="modal fade"
        id="subscribtionModal"
        tabindex="-1"
        aria-labelledby="subscribtionModalLabel"
        aria-hidden="true"
        :class="[show ? ['d-block', 'show'] : '']"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button
              type="button"
              class="btn-nulled text-secondary fw-bold position-absolute btn-close-custom"
              aria-label="Close"
              @click="handleCloseModalForm"
          >
            CLOSE
          </button>
          <div class="modal-header d-flex align-items-center flex-column border-0">
            <img :src="successModalData.logo.link" :alt="successModalData.logo.alt" />
          </div>
          <div class="modal-body">
            <p class="h2 text-primary text-center">{{modal.form.title}}</p>
            <div v-html="modal.form.description" class="modal-desc" />
            <form>
              <div class="form-section">
                <p class="h4">{{ modal.form.aboutYou.title }}</p>
                <div class="d-grid wrapper">
                  <div>
                    <label for="firstName">{{ modal.form.aboutYou.firstName.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYou.firstName.placeholder"
                        id="firstName"
                        v-model="state.firstName"
                        class="w-100"
                        :warning="v$.firstName.$error"
                    />
                    <span v-if="v$.firstName.$error" class="d-inline-block mt-1 text-secondary">{{ v$.firstName.$errors[0].$message }}</span>
                  </div>
                  <div>
                    <label for="lastName">{{ modal.form.aboutYou.lastName.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYou.lastName.placeholder"
                        v-model="state.lastName"
                        :warning="v$.lastName.$error"
                    />
                    <span v-if="v$.lastName.$error" class="d-inline-block mt-1 text-secondary">{{ v$.lastName.$errors[0].$message }}</span>
                  </div>
                  <div>
                    <label for="role">{{ modal.form.aboutYou.role.label }}</label>
                    <Input :placeholder="modal.form.aboutYou.role.placeholder" id="role" v-model="state.role" />
                  </div>
                  <div>
                    <label for="phone">{{ modal.form.aboutYou.phone.label }}</label>
                    <Input :placeholder="modal.form.aboutYou.phone.placeholder" id="phone" v-model="state.phone" />
                  </div>
                  <div>
                    <label for="email">{{ modal.form.aboutYou.email.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYou.email.placeholder"
                        v-model="state.email"
                        :warning="v$.email.$error"
                    />
                    <span v-if="v$.email.$error" class="d-inline-block mt-1 text-secondary">{{ v$.email.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>
              <div class="form-section">
                <p class="h4">{{ modal.form.aboutYourOrg.title }}</p>
                <div class="d-grid wrapper">
                  <div class="company-field">
                    <label for="company">{{ modal.form.aboutYourOrg.companyName.label }}</label>
                    <Input
                        :placeholder="modal.form.aboutYourOrg.companyName.placeholder"
                        id="company"
                        v-model="state.company"
                        :warning="v$.company.$error"
                    />
                    <span v-if="v$.company.$error" class="d-inline-block mt-1 text-secondary">{{ v$.company.$errors[0].$message }}</span>
                  </div>
                  <div>
                    <label>{{ modal.form.aboutYourOrg.industry.label }}</label>
                    <Select
                        :options="state.industryOptions"
                        v-model="state.industry"
                        :placeholder="modal.form.aboutYourOrg.industry.placeholder"
                        :searchable="false"
                        :warning="v$.industry.$error"
                    />
                  </div>
                  <div>
                    <label for="city">{{ modal.form.aboutYourOrg.city.label }}</label>
                    <Select
                        :warning="v$.city.$error"
                        :placeholder="modal.form.aboutYourOrg.city.placeholder"
                        :searchable="false"
                        :autocomplete="true"
                        :autocompleteOptions="state.autocompleteOptions"
                        @placeChanged="handleLocation"
                        :modelValue="state.city"
                    />
                  </div>
                  <div>
                    <label>{{ modal.form.aboutYourOrg.state.label }}</label>
                    <v-select
                        :options="state.stateOptions"
                        class="select-standard"
                        :class="{'item-danger': v$.state.$error}"
                        :searchable="false"
                        :placeholder="modal.form.aboutYourOrg.state.placeholder"
                        v-model="state.state"
                    />
                  </div>
                  <div>
                    <label>{{ modal.form.aboutYourOrg.country.label }}</label>
                    <v-select
                        label="title"
                        :options="state.countryOptions"
                        class="select-standard"
                        :class="{'item-danger': v$.country.$error}"
                        :searchable="false"
                        :placeholder="modal.form.aboutYourOrg.country.placeholder"
                        @option:selected="(option) => handleSelected(option, 'country')"
                        v-model="state.country"
                    />
                  </div>
                  <div class="source-field">
                    <label for="source">{{ modal.form.aboutYourOrg.source.label }}</label>
                    <Input :placeholder="modal.form.aboutYourOrg.source.placeholder" id="source" v-model="state.source" />
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex align-items-center checkbox-email">
                  <Checkbox v-model:checked="state.subscribeEmail" id="confirmReceivingEmailsCheckbox" class="bg-white me-2" />
                  <p>{{ modal.form.checkbox}}</p>
              </div>
              <div class="d-flex justify-content-center mx-auto mb-3">
                  <ButtonRed
                      :loading="isLoading"
                      :disabled="isLoading"
                      :text="modal.form.button.text"
                      @click="handleSubmit"
                      :type="null"
                      class="btn-confirm"
                  />
              </div>
              <button
                  type="button"
                  class="btn-nulled text-secondary d-block mx-auto"
                  aria-label="Close"
                  @click="handleCloseModalForm"
              >
                {{ modal.form.rejectSubscriptionButton.text }}
              </button>
            </form>
          </div>
          <ErrorBlock v-if="defineFormError(v$)" :errors="defineFormError(v$)" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {computed, onMounted, reactive, watch} from 'vue';
  import ButtonRed from "@/components/common/ButtonRed";
  import Input from "@/components/common/Input";
  import Select from "@/components/common/Select";
  import Checkbox from "@/components/common/Checkbox";
  import ErrorBlock from "@/components/common/ErrorBlock";
  import SuccessModal from "@/components/common/modals/SuccessModal";
  import useLoadData from "@/composables/useLoadData";
  import {useReCaptcha} from "vue-recaptcha-v3";
  import {useRouter} from "vue-router";
  import {contactUsValidationOptions, defineFormError} from "@/utils/validators";
  import {useVuelidate} from "@vuelidate/core";
  import {parseLocation} from "@/utils/utils";
import TextArea from "@/components/common/TextArea";
import submitFormToGa from "@/utils/submitFormToGa";

export default {
  components: {ButtonRed, Checkbox, Select, Input, ErrorBlock, TextArea, SuccessModal},
  data(){
    return {
      defineFormError
    }
  },
  props: {
    modal: {
      form: {
        name: String,
        title: String,
        description: HTMLElement,
        aboutYou: {
          title: String,
          firstName: {
            placeholder: String,
            label: String
          },
          lastName: {
            placeholder: String,
            label: String
          },
          role: {
            placeholder: String,
            label: String
          },
          phone: {
            placeholder: String,
            label: String
          },
          email: {
            placeholder: String,
            label: String
          },
        },
        aboutYourOrg: {
          title: String,
          companyName: {
            placeholder: String,
            label: String
          },
          industry: {
            placeholder: String,
            label: String
          },
          state: {
            placeholder: String,
            label: String
          },
          city: {
            placeholder: String,
            label: String
          },
          country: {
            label: String,
            placeholder: String
          },
          source: {
            label: String,
            placeholder: String
          },
        },
        checkbox: String,
        button: {
          text: String
        },
        rejectSubscriptionButton: {
          text: String
        }
      }
    },
    successModalData: {
      logo: {
        link: String,
        alt: String
      },
      title: String,
      description: String,
      buttonText: String
    },
    show: Boolean
  },
  emits: ['handleModal'],
  setup(props, {emit}){
    const { data: formSubmitResponse, fetchData: sendForm, isLoading } = useLoadData()
    const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
    const router = useRouter();
    const countryOptions = props.modal?.form?.aboutYourOrg?.countries.map(country => country.name);
    const industryOptions = props.modal?.form?.aboutYourOrg?.industry.options;
    const formName = props.modal.form.name
    const usaStates = props.modal?.form?.aboutYourOrg?.countries.filter(countryObject => countryObject.name === 'USA')[0].states.map(elem => elem.name)
    const canadaStates = props.modal?.form?.aboutYourOrg?.countries.filter(countryObject => countryObject.name !== 'USA')[0].states.map(elem => elem.name)

    const handleTextarea = (status) => {
      state.textarea.focus = status
    }

    const state = reactive({
      showSuccessModal: false,
      firstName: '',
      lastName: '',
      role: '',
      phone: '',
      email: '',
      company: '',
      industry: '',
      industryOptions,
      state: '',
      stateOptions: countryOptions[0] === 'USA' ? usaStates : canadaStates,
      city: '',
      country: countryOptions && countryOptions[0],
      countryOptions,
      source: '',
      subscribeEmail: false,
      autocompleteOptions: {
        componentRestrictions: {'country': ['US', 'CA']},
        types: ['(cities)']
      },
      addressAutocompleteOptions: {
        componentRestrictions: {'country': ['US', 'CA']},
        types: ['address']
      }
    })

    const recaptcha = async () => {
      isLoading.value = true;
      const data = {
        formName: formName,
        fields: [
          {name: 'firstName', value: state.firstName},
          {name: 'lastName', value: state.lastName},
          {name: 'role', value: state.role},
          {name: 'phone', value: state.phone},
          {name: 'email', value: state.email},
          {name: 'company', value: state.company},
          {name: 'industry', value: state.industry},
          {name: 'city', value: state.city},
          {name: 'state', value: state.state},
          {name: 'country', value: state.country},
          {name: 'source', value: state.source},
          {name: 'subscribeEmail', value: state.subscribeEmail},
        ],
      }

      // (optional) Wait until recaptcha has been loaded.
      await recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await executeRecaptcha('login')

      await sendForm({
        url: '/form-submit',
        method: 'post',
        data: {
          ...data,
          recaptchaToken: token
        }
      })

      submitFormToGa(formName);
    }

    let rules = computed(() => contactUsValidationOptions);

    const v$ = useVuelidate(rules, state);

    const handleLocation = (place, additional, addressField) => {
      parseLocation(place, (locationInfo) => {
        if(!additional){
          state.city = locationInfo.city
          state.stateOptions = (locationInfo.info.country === 'United States') ? usaStates : canadaStates
          state.state = (locationInfo.info.country === 'United States' ? usaStates : canadaStates)
              .filter(state => state === locationInfo.info.administrative_area_level_1)[0]
          state.country = locationInfo.info.country === 'United States' ? 'USA' : 'Canada'
        } else {
          addressField && (state.aboutTheLocation.address = locationInfo.formatted_address)
          state.aboutTheLocation.city = locationInfo.city ? locationInfo.city : locationInfo.info.administrative_area_level_1
          state.aboutTheLocation.stateOptions = (locationInfo.info.country === 'United States') ? usaStates : canadaStates
          state.aboutTheLocation.state = (locationInfo.info.country === 'United States' ? usaStates : canadaStates)
              .filter(state => state === locationInfo.info.administrative_area_level_1)[0]
          state.aboutTheLocation.country = locationInfo.info.country === 'United States' ? 'USA' : 'Canada'
          locationInfo.info?.postal_code && (state.aboutTheLocation.zip = locationInfo.info.postal_code)
        }
      })
    }

    const handleSelected = (option, keyName, additional) => {
      if(!additional) {
        state[keyName] = option
        option === 'USA' ? (state.stateOptions = usaStates) : (state.stateOptions = canadaStates)
      } else {
        state.aboutTheLocation[keyName] = option
        option === 'USA' ?
            (state.aboutTheLocation.stateOptions = usaStates) :
            (state.aboutTheLocation.stateOptions = canadaStates)
      }
    }

    watch(() => props.show, () => {
      const main = document.querySelector('main');

      document.querySelector('body').classList.toggle('overflow-hidden')
      main.style.zIndex = (window.getComputedStyle(main).zIndex === 'auto' ? '1300' : 'auto')
    })

    return {
      handleTextarea,
      state,
      handleSelected,
      handleLocation,
      v$,
      recaptcha,
      isLoading
    }
  },
  methods: {
    async handleSubmit(){
      await this.v$.$validate()

      if(!this.v$.$error && !this.isLoading) {
        this.recaptcha();
        this.$emit('handleModal')
        this.state.showSuccessModal = true
        document.cookie = "subscription=subscribed; path=/;"
      }
    },
    clearForm() {
      this.state.firstName = ''
      this.state.lastName = ''
      this.state.role = ''
      this.state.phone = ''
      this.state.email = ''
      this.state.company = ''
      this.state.industry = ''
      this.state.city = ''
      this.state.state = ''
      this.state.country = 'USA'
      this.state.source = ''
      this.state.subscribeEmail = false

      this.v$.firstName.$reset()
      this.v$.lastName.$reset()
      this.v$.email.$reset()
      this.v$.company.$reset()
      this.v$.industry.$reset()
      this.v$.phone.$reset()
      this.v$.country.$reset()
      this.v$.city.$reset()
      this.v$.state.$reset()
      this.v$.country.$reset()
    },
    handleSuccessModal()  {
      this.state.showSuccessModal = false
      this.clearForm()
    },
    handleCloseModalForm () {
      this.$emit('handleModal')
      this.clearForm()

      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 7);
      document.cookie = `subscription=rejected; expires=${expirationDate.toUTCString()}; path=/;`;
    },
  },
}
</script>
